import React, { useEffect, useState, useCallback } from "react";
import {header, Multipartheader} from "../../Components/Url/ApiUrl";
import swal from "sweetalert";
import { Logout } from "../../Components/Actions/Actions";
import CompanyModal from "./EditCompany";
import axios from "axios";
import {useTranslation} from "react-i18next";

const Company = ({regions,user}) => {
    const {t} = useTranslation();
    const [data, setData] = useState(null);
    const [logo, setLogo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({});
    const [showModal, setShowModal] = useState(false);

    const fetchLogo = useCallback(async (logoName) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/files/logo/${logoName}`, {
                method: "GET",
                headers: header,
            });
            if (!response.ok) throw new Error(t('logo_not_loaded'));
            const blob = await response.blob();
            setLogo(URL.createObjectURL(blob));
        } catch (error) {
            console.error('Logo fetch xatosi:', error);
        }
    }, [t]);

    const handleFetch = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/company/company`, {
                method: "GET",
                headers: header,
            });
            if (response.status === 401) {
                Logout();
                return;
            }
            if (!response.ok) {
                throw new Error(t('translation:no_data_found'));
            }
            const companyData = await response.json();
            setData(companyData);
            if (companyData.logo) {
                fetchLogo(companyData.logo);
            }
        } catch (error) {
            console.error('Company fetch xatosi:', error);
            swal(t('error'), error.message || t('unknown_error'), "error");
        } finally {
            setLoading(false);
        }
    }, [fetchLogo, t]);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    const toggleEditMode = () => {
        setFormData(data);
        setShowModal(true);
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSave = async () => {
        try {
            let form = new FormData();
            for (const key in formData) {
                form.append(key, formData[key]);
            }
            const res = await axios
                .post(
                    process.env.REACT_APP_API_ENDPOINT + '/company/company',
                    form,
                    {
                        headers:Multipartheader
                    });
            if (!res.data || !res.data?.success) {
                const message = res.data?.message;
                let firstError = "Saqlashda xatolik yuz berdi";

                if (message && typeof message === 'object') {
                    const firstKey = Object.keys(message)[0];
                    if (firstKey && Array.isArray(message[firstKey])) {
                        firstError = message[firstKey][0];
                    }
                }

                swal(t('error'), firstError, "error");
                throw new Error(firstError);
            }
            setShowModal(false);
            handleFetch();
        } catch (error) {
            const message = error?.message;
            let firstError = t('translation:saving_error');

            if (message && typeof message === 'object') {
                const firstKey = Object.keys(message)[0];
                if (firstKey && Array.isArray(message[firstKey])) {
                    firstError = message[firstKey][0];
                }
            }else{
                firstError = message
            }
            swal(t('error'), firstError || t('translation:unknown_error'), "error");
        }
    }

    const handleCancel = () => {
        setShowModal(false);
    }

    if (loading) {
        return <div className="loading-spinner">{t('loading')}</div>;
    }

    if (!data) {
        return <div>{t('error_occured')}</div>;
    }
    return (
        <div className="company-view">
            <div className="d-flex pb-3">
                <h3 className="m-0 me-2">{t('my_company')}</h3>
                {Boolean(user.can_update) && (
                    <button
                        className="btn btn-rounded btn-outline-primary p-0"
                        style={{width: "32px", height: "32px"}}
                        onClick={toggleEditMode}
                    >
                        <i className="bi bi-pencil-fill"></i>
                    </button>
                )}
            </div>
            {
                user.can_update ?
                    <CompanyModal
                        show={showModal}
                        handleClose={handleCancel}
                        formData={formData}
                        setFormData={setFormData}
                        handleInputChange={handleInputChange}
                        handleSave={handleSave}
                        logo={logo}
                        setLogo={setLogo}
                        regions={regions}
                    />
                    : ''
            }
            <table id="w0" className="table table-striped table-bordered detail-view">
                <tbody>
                <tr>
                    <th style={{width: "300px"}}>{t('company_name')}</th>
                    <td>{data.name}</td>
                </tr>
                <tr>
                    <th>{t('company_type')}</th>
                    <td>{data.type}</td>
                </tr>
                <tr>
                    <th>{t('company_region')}</th>
                    <td>{data.regName}</td>
                </tr>
                <tr>
                    <th>{t('company_legal_address')}</th>
                    <td>{data.address}</td>
                </tr>
                <tr>
                    <th>{t('company_phone')}</th>
                    <td>{data.phone}</td>
                </tr>
                <tr>
                    <th>{t('company_email')}</th>
                    <td><a href={`mailto:${data.email}`}>{data.email}</a></td>
                </tr>
                <tr>
                    <th>{t('company_logo')}</th>
                    <td>
                        {logo ? (
                            <img className="company-logo" src={logo} alt={t('company_logo')}/>
                        ) : (
                            t('no_logo')
                        )}
                    </td>
                </tr>
                <tr>
                    <th>{t('company_website')}</th>
                    <td>{data.site}</td>
                </tr>
                <tr>
                    <th>{t('company_bank')}</th>
                    <td>{data.bank}</td>
                </tr>
                <tr>
                    <th>{t('mfo')}</th>
                    <td>{data.mfo}</td>
                </tr>
                <tr>
                    <th>{t('stir')}</th>
                    <td>{data.stir}</td>
                </tr>
                <tr>
                    <th>{t('xtut_code')}</th>
                    <td>{data.xtut}</td>
                </tr>
                <tr>
                    <th>{t('about_company')}</th>
                    <td>{data.about}</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Company;
